import "@/client/libs/dayjs";

import { i18n } from "@lingui/core";
import { detect, fromStorage, fromUrl } from "@lingui/detect-locale";
import { I18nProvider } from "@lingui/react";
import { languages } from "@reactive-resume/utils";
import { useEffect } from "react";

import { defaultLocale, dynamicActivate } from "../libs/lingui";
import { updateUser } from "../services/user";
import { useAuthStore } from "../stores/auth";

type Props = {
  children: React.ReactNode;
};
export const LocaleProvider = ({ children }: Props) => {
  const userLocale = "en-US";

  useEffect(() => {
    const detectedLocale = detect(
      fromUrl("locale"),
      fromStorage("locale"),
      userLocale,
      defaultLocale,
    )!;

    // Activate the locale only if it's supported
    if (languages.some((lang) => lang.locale === detectedLocale)) {
      //console.log("detedted", defaultLocale, detectedLocale);
      dynamicActivate(detectedLocale);
    } else {
      dynamicActivate(defaultLocale);
    }
    //console.log("Inside locale file tsx");
    // Parse the URL parameters
    const urlSearchParams = new URLSearchParams(window.location.search);

    const dlid = urlSearchParams.get("token");
    // alert(dlid)
    // Check if dlid exists and save it to local storage
    if (dlid) {
      // alert(dlid)
      // sessionStorage.setItem("token", dlid);
    }
  }, [userLocale]);

  return <I18nProvider i18n={i18n}>{children}</I18nProvider>;
};

export const changeLanguage = async (locale: string) => {
  // Update locale in local storage
  window.localStorage.setItem("locale", locale);

  // Update locale in user profile, if authenticated
  const state = useAuthStore.getState();
  if (state.user) await updateUser({ locale }).catch(() => null);

  // Reload the page for language switch to take effect
  window.location.reload();
};
